/**
 * Bögrebolt: max total quantity in cart.
 * Shows a modal when the customer would exceed the limit.
 */
(function () {
  var LIMIT = 50;
  var CONTACT_URL = '/pages/contact';
  var TITLE = 'Egyeztetés szükséges';
  var BODY =
    'Egyszerre legfeljebb ' +
    LIMIT +
    ' bögrét tudsz a kosárba tenni. Nagyobb mennyiségnél írj nekünk, és egyeztetünk.';
  var BTN_OK = 'Értem';
  var BTN_CONTACT = 'Kapcsolat';

  function ensureModal() {
    var el = document.getElementById('bogrebolt-cart-limit-modal');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'bogrebolt-cart-limit-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'bogrebolt-cart-limit-title');
    el.hidden = true;
    el.innerHTML =
      '<div class="bogrebolt-cart-limit__backdrop" data-close></div>' +
      '<div class="bogrebolt-cart-limit__panel">' +
      '<h2 id="bogrebolt-cart-limit-title">' +
      TITLE +
      '</h2>' +
      '<p>' +
      BODY +
      '</p>' +
      '<div class="bogrebolt-cart-limit__actions">' +
      '<button type="button" class="bogrebolt-cart-limit__btn bogrebolt-cart-limit__btn--primary" data-close>' +
      BTN_OK +
      '</button>' +
      '<a class="bogrebolt-cart-limit__btn bogrebolt-cart-limit__btn--secondary" href="' +
      CONTACT_URL +
      '">' +
      BTN_CONTACT +
      '</a>' +
      '</div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      if (e.target && e.target.hasAttribute('data-close')) hideModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hidden) hideModal();
    });
    return el;
  }

  function showModal() {
    var el = ensureModal();
    el.hidden = false;
    document.documentElement.classList.add('bogrebolt-cart-limit-open');
  }

  function hideModal() {
    var el = document.getElementById('bogrebolt-cart-limit-modal');
    if (el) el.hidden = true;
    document.documentElement.classList.remove('bogrebolt-cart-limit-open');
  }

  function cartItemCount(cart) {
    if (!cart) return 0;
    if (typeof cart.item_count === 'number') return cart.item_count;
    if (Array.isArray(cart.items)) {
      return cart.items.reduce(function (sum, item) {
        return sum + (Number(item.quantity) || 0);
      }, 0);
    }
    return 0;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function parseBody(init) {
    if (!init || init.body == null) return null;
    var body = init.body;
    if (typeof body === 'string') {
      try {
        return JSON.parse(body);
      } catch (e) {
        try {
          var params = new URLSearchParams(body);
          var obj = {};
          params.forEach(function (v, k) {
            obj[k] = v;
          });
          return obj;
        } catch (e2) {
          return null;
        }
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var o = {};
      body.forEach(function (v, k) {
        o[k] = v;
      });
      return o;
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      var u = {};
      body.forEach(function (v, k) {
        u[k] = v;
      });
      return u;
    }
    return null;
  }

  function urlPath(input) {
    try {
      var u = typeof input === 'string' ? new URL(input, location.origin) : new URL(input.url, location.origin);
      return u.pathname;
    } catch (e) {
      return String(input || '');
    }
  }

  function requestedAddQty(payload) {
    if (!payload) return 1;
    if (Array.isArray(payload.items)) {
      return payload.items.reduce(function (sum, item) {
        return sum + (Number(item.quantity) || 1);
      }, 0);
    }
    if (payload.quantity != null) return Number(payload.quantity) || 1;
    return 1;
  }

  function wouldExceedOnAdd(cart, payload) {
    return cartItemCount(cart) + requestedAddQty(payload) > LIMIT;
  }

  function wouldExceedOnChange(cart, payload) {
    if (!payload || !cart || !Array.isArray(cart.items)) return false;
    var items = cart.items.slice();
    var qty = payload.quantity != null ? Number(payload.quantity) : null;
    if (qty == null) return false;

    if (payload.line != null) {
      var lineIndex = Number(payload.line) - 1;
      if (lineIndex >= 0 && lineIndex < items.length) items[lineIndex].quantity = qty;
    } else if (payload.id != null) {
      var id = String(payload.id);
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].key) === id || String(items[i].variant_id) === id || String(items[i].id) === id) {
          items[i].quantity = qty;
          break;
        }
      }
    } else if (payload.updates && typeof payload.updates === 'object') {
      Object.keys(payload.updates).forEach(function (key) {
        var newQty = Number(payload.updates[key]);
        for (var j = 0; j < items.length; j++) {
          if (String(items[j].key) === key || String(items[j].variant_id) === key || String(items[j].id) === key) {
            items[j].quantity = newQty;
          }
        }
      });
    } else {
      return false;
    }

    var total = items.reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);
    return total > LIMIT;
  }

  function blockedResponse() {
    return new Response(
      JSON.stringify({
        status: 422,
        message: BODY,
        description: BODY,
        bogrebolt_cart_limit: true,
      }),
      {
        status: 422,
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var path = urlPath(input);
    var isAdd = /\/cart\/add(\.js)?$/.test(path);
    var isChange = /\/cart\/change(\.js)?$/.test(path);
    var isUpdate = /\/cart\/update(\.js)?$/.test(path);
    if (!isAdd && !isChange && !isUpdate) {
      return originalFetch.apply(this, arguments);
    }

    var payload = parseBody(init);
    return fetchCart()
      .then(function (cart) {
        var exceed = false;
        if (isAdd) exceed = wouldExceedOnAdd(cart, payload);
        else exceed = wouldExceedOnChange(cart, payload);
        if (exceed) {
          showModal();
          return blockedResponse();
        }
        return originalFetch.apply(window, [input, init]);
      })
      .catch(function () {
        return originalFetch.apply(window, [input, init]);
      });
  };

  if (!document.getElementById('bogrebolt-cart-limit-style')) {
    var style = document.createElement('style');
    style.id = 'bogrebolt-cart-limit-style';
    style.textContent =
      '#bogrebolt-cart-limit-modal{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:24px;}' +
      '#bogrebolt-cart-limit-modal[hidden]{display:none!important;}' +
      '.bogrebolt-cart-limit__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.45);}' +
      '.bogrebolt-cart-limit__panel{position:relative;max-width:420px;width:100%;background:#fff;color:#111;border-radius:12px;padding:24px;box-shadow:0 16px 48px rgba(0,0,0,.2);font-family:inherit;}' +
      '.bogrebolt-cart-limit__panel h2{margin:0 0 12px;font-size:1.25rem;line-height:1.3;}' +
      '.bogrebolt-cart-limit__panel p{margin:0 0 20px;line-height:1.5;}' +
      '.bogrebolt-cart-limit__actions{display:flex;flex-wrap:wrap;gap:10px;}' +
      '.bogrebolt-cart-limit__btn{display:inline-flex;align-items:center;justify-content:center;padding:10px 16px;border-radius:8px;text-decoration:none;border:1px solid #111;cursor:pointer;font:inherit;}' +
      '.bogrebolt-cart-limit__btn--primary{background:#111;color:#fff;}' +
      '.bogrebolt-cart-limit__btn--secondary{background:#fff;color:#111;}' +
      'html.bogrebolt-cart-limit-open{overflow:hidden;}';
    document.head.appendChild(style);
  }

  // Pre-create modal after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureModal);
  } else {
    ensureModal();
  }
})();
